import {
    ENTITY_PART_TYPE_SEPARATOR,
    ENTITY_PART_TYPE_TCE,
} from '_legacy/models/common/EntityPart';
import { LocationPartInput } from './TceInput';

export interface TceValue {
    rate: number;
    ballastBonus: number | undefined;
    balticIndex: string;
    delivery: LocationPartInput;
    redelivery: LocationPartInput;
}

export interface TcePart {
    partType: string;
    tceValue: TceValue | null;
    separatorValue: string | null;
}

export const createTcePart = (
    rate: number,
    ballastBonus: number | undefined,
    balticIndex: string,
    delivery: LocationPartInput,
    redelivery: LocationPartInput
): TcePart => {
    const tceValue = createTceValue(
        rate,
        ballastBonus,
        balticIndex,
        delivery,
        redelivery
    );
    return createPart(tceValue, null, ENTITY_PART_TYPE_TCE);
};

export const createSeparatorTcePart = (character) => {
    return createPart(null, character, ENTITY_PART_TYPE_SEPARATOR);
};

const createTceValue = (
    rate: number,
    ballastBonus: number | undefined,
    balticIndex: string,
    delivery: LocationPartInput,
    redelivery: LocationPartInput
): TceValue => {
    return {
        rate: rate,
        ballastBonus: ballastBonus,
        balticIndex: balticIndex,
        delivery: delivery,
        redelivery: redelivery,
    };
};

const createPart = (
    tceValue: TceValue | null,
    separatorValue: string | null,
    partType: string
): TcePart => {
    return {
        partType,
        tceValue,
        separatorValue,
    };
};
